<template>
    <button :disabled="props.disabled" type="button" class="paybtn interactable" ref="payBtnElement" />
</template>

<script setup lang="ts">
    import { PayButton } from "@/app/elements/PayButton";
    import { onMounted, ref, watch } from "vue";

    const props = defineProps<{
        action: string;
        disabledMessage?: string;
        amount?: number | string;
        disabled?: boolean;
    }>();

    let payBtn: PayButton;
    const payBtnElement = ref<HTMLElement | null>(null);

    onMounted(() => {
        payBtn = new PayButton(props.action, $(payBtnElement.value!));
        if (props.disabled) {
            payBtn.setDisabled();
        }

        if (props.amount) {
            payBtn.setAmount(props.amount);
        }
    });

    // the label is written into the jquery button at mount, so a language switch reaches it
    // only through this watch - the action text is separate from the disabled message, which
    // setDisabled puts in the amount slot, so this is safe while the button is disabled
    watch(
        () => props.action,
        (action) => {
            payBtn.setAction(action);
        }
    );

    watch(
        () => props.disabled,
        (disabled) => {
            if (disabled) {
                payBtn.setDisabled(props.disabledMessage);
            } else {
                payBtn.setEnabled();
            }
        }
    );

    watch(
        () => props.amount,
        (amount) => {
            if (amount !== undefined) {
                payBtn.setAmount(amount);
            }
        }
    );

    watch(
        () => props.disabledMessage,
        (disabledMessage) => {
            if (props.disabled) {
                payBtn.setDisabled(disabledMessage);
            } else {
                payBtn.setEnabled();
            }
        }
    );
</script>
